import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function JetMediaShuttleWorkflowSending() {
    return (
        <React.Fragment>
            <p>
                The{' '}
                <a
                    href="https://developer.signiant.com/media-shuttle/s2p-integration-guide.html"
                    target="_blank"
                    rel="noreferrer"
                >
                    Media Shuttle System-to-Person Automation API
                </a>{' '}
                can also be used to integrate both Signiant applications. When a Jet job transfers content to the
                destination endpoint in the perimeter network, that content also becomes available within the portal
                storage. The System-to-Person API can be used to create a Media Shuttle package with the content, then
                sends a generated URL to a user who can then download the content.
            </p>
        </React.Fragment>
    );
}

JetMediaShuttleWorkflowSending.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JetMediaShuttleWorkflowSending);
